import * as actionTypes from './ActionTypes';
import {postRequest, getRequest,putRequest} from '../Helper/ApiHit'

//-------------------- API VIEW JOB PROFILE - DEEPAK ------------------------------------------------------

export const viewJobProfile = (page)=>{
    return (dispatch)=>{
           dispatch({type:actionTypes.VIEW_JOB_PROFILE_INITIAL});
           postRequest(`employer/viewJobProfile?page=${page}&limit=6`,{"searchByJobTitleOrSkill": []})
                    .then(res=>{
                      
                        const record = res.data.responseData.commonPaginationResponse==undefined?0:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
                        if(res.data.responseData.jobProfileDetails==undefined){
                            return dispatch({
                                type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                                payload : false,
                                nodata:true
                                })
                        }
                        const newArr = res.data.responseData.jobProfileDetails.map(element=>{
                            return (
                                {
                                    jobTitle: element.jobTitle,
                                    id:element.id,
                                    created:element.created,
                                    clientName:element.clientName,
                                    maxExperience: element.maxExperience,
                                    minExperience: element.minExperience,
                                    mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
                                    otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
                                    otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
                                    preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[],
                                    allJobSkillsWithPreecedence: element.allJobSkillsWithPreecedence !==null?element.allJobSkillsWithPreecedence:[],
                                    candidateId: element.candidateId
                                }
                            )
                        })

                    
                     if(res.data.responseStatus.statusCode ===0 ){
                         return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_SUCCESS,
                             payload :newArr,
                             records:record
                         })    
                     }
                     else{
                        return dispatch({
                            type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                            payload:false,
                            nodata:true
                        })
                     }
                    }).catch(err=>{
                        return dispatch({
                            type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                            payload:true,
                            nodata:false
                        })                   })
    }
}

//-------------------- API SEARCH JOB PROFILE - DEEPAK ------------------------------------------------------
export const searchJobProfile = (searchArray,page)=>{
    return (dispatch)=>{
           dispatch({type:actionTypes.VIEW_JOB_PROFILE_INITIAL});
           postRequest(`employer/viewJobProfile?page=${page}&limit=6`,{"searchByJobTitleOrSkill": searchArray })
                    .then(res=>{
                   
                        const record = res.data.responseData.commonPaginationResponse==undefined?0:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
                        if(res.data.responseData.jobProfileDetails==undefined){
                            return dispatch({
                                type:actionTypes.SEARCH_JOB_PROFILE_EMPTY
                                })
                        }
                        const newArr = res.data.responseData.jobProfileDetails.map(element=>{
                            return (
                                {
                                    jobTitle: element.jobTitle,
                                    id:element.id,
                                    created:element.created,
                                    clientName:element.clientName,
                                    maxExperience: element.maxExperience,
                                    minExperience: element.minExperience,
                                    mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
                                    otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
                                    otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
                                    preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[],
                                    allJobSkillsWithPreecedence: element.allJobSkillsWithPreecedence !==null?element.allJobSkillsWithPreecedence:[],
                                    candidateId: element.candidateId
                                }
                            )
                        })

                     if(res.data.responseStatus.statusCode ===0 ){
                         return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_SUCCESS,
                             payload :newArr,
                             records:record
                         })    
                     }
                     else{
                         return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                             payload:false,
                             nodata:true
                         })
                     }
                    }).catch(err=>{
                        return dispatch({
                        type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                        payload : true,
                        nodata:false
                        })
                    })
    }
}


//-------------------- API VIEW SINGLE JOB PROFILE - DEEPAK ------------------------------------------------------

// export const viewSingleJobProfile = (id)=>{
//     return (dispatch)=>{
//            dispatch({type:actionTypes.VIEW_SINGLE_JOB_PROFILE_INITIAL});
//            getRequest(`employer/viewJobProfile?jobId=${id}`)
//            .then(res=>{
//             //    console.log(res);
//             if(res.data.responseStatus.statusCode ===0 ){
//                 const newArr = res.data.responseData.jobProfileDetails.map(element=>{
//                     return (
//                         {
//                             jobTitle: element.jobTitle,
//                             id:element.id,
//                             created:element.created,
//                             maxExperience: element.maxExperience,
//                             minExperience: element.minExperience,
//                             mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
//                             otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
//                             otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
//                             preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[]
//                         }
//                     )
//                 })
//                 getRequest(`master/getSkillMaster`)
//            .then(res=>{
//                 console.log(res);
//             if(res.data.responseStatus.statusCode ===0 ){
//                 return dispatch({
//                     type:actionTypes.GET_SKILLS_SUCCESS,
//                     payload :res.data.responseData.skillList,
//                 })    
//             }
//             else{
//                 return dispatch({
//                     type:actionTypes.GET_SKILLS_FAIL,
//                     payload :res.data.responseData.message
//                 })
//             }
//            })
//            .catch(error =>{
//             return dispatch({
//                 type:actionTypes.GET_SKILLS_FAIL,
//                 payload :"Server Error"
//             })
//            })
//                 return dispatch({
//                     type:actionTypes.VIEW_SINGLE_JOB_PROFILE_SUCCESS,
//                     payload :newArr,
//                 })    
//             }
//             else{
//                 return dispatch({
//                     type:actionTypes.VIEW_SINGLE_JOB_PROFILE_FAIL,
//                     payload :res.data.responseData.message
//                 })
//             }
//            })
//            .catch(error =>{
//             return dispatch({
//                 type:actionTypes.VIEW_SINGLE_JOB_PROFILE_FAIL,
//                 payload :"Server Error"
//             })
//            })
//     }
// }

//-------------------- API GET SKILLS MASTER JOB PROFILE - DEEPAK ------------------------------------------------------

export const getSkillsMaster = ()=>{
    return (dispatch)=>{
           dispatch({type:actionTypes.GET_SKILLS_INITIAL});
           getRequest(`master/getSkillMaster`)
           .then(res=>{
              
            if(res.data.responseStatus.statusCode ===0 ){
                return dispatch({
                    type:actionTypes.GET_SKILLS_SUCCESS,
                    payload :res.data.responseData.skillList,
                })    
            }
            else{
                return dispatch({
                    type:actionTypes.GET_SKILLS_FAIL,
                    payload :res.data.responseData.message
                })
            }
           })
           .catch(error =>{
            return dispatch({
                type:actionTypes.GET_SKILLS_FAIL,
                payload :"Server Error"
            })
           })
    }
}

//-------------------- API UPDATE JOB PROFILE - DEEPAK ------------------------------------------------------

export const updateJobProfile = (data,page)=>{
    return (dispatch)=>{
        dispatch({type:actionTypes.UPDATE_JOB_PROFILE_INITIAL});
        postRequest(`candidate/updateJobProfile`,data)
        .then(res=>{
         if(res.data.responseStatus.statusCode === 0 ){
                 const newres = res
                 postRequest(`employer/viewJobProfile?page=${page}&limit=6`,{"searchByJobTitleOrSkill": []})
                 .then(res=>{
             
                  if(res.data.responseStatus.statusCode ===0 ){

                    const newArr = res.data.responseData.jobProfileDetails.map(element=>{
                        return (
                            {
                                jobTitle: element.jobTitle,
                                id:element.id,
                                created:element.created,
                                clientName:element.clientName,
                                maxExperience: element.maxExperience,
                                minExperience: element.minExperience,
                                mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
                                otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
                                otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
                                preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[],
                                allJobSkillsWithPreecedence: element.allJobSkillsWithPreecedence !==null?element.allJobSkillsWithPreecedence:[],
                                candidateId: element.candidateId
                            }
                        )
                    })
                      return dispatch({
                          type:actionTypes.VIEW_JOB_PROFILE_SUCCESS,
                          payload :newArr,
                          records:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
                      })    
                  }
                  else{
                      return dispatch({
                          type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                          // payload :res.data.responseData.message
                      })
                  }
                 }).then(res=>{
                 return dispatch({
                     type:actionTypes.UPDATE_JOB_PROFILE_SUCCESS,
                     payload:true
                 })   
                 })
               
         }
         else{
             return dispatch({
                 type:actionTypes.UPDATE_JOB_PROFILE_FAIL,
                 payload : true
             })
         }
        })
        .catch(error =>{
         return dispatch({
             type:actionTypes.UPDATE_JOB_PROFILE_FAIL,
             payload :"Server Error"
         })
        })
 }
}

//-------------------- API ARCHIVE JOB PROFILE - DEEPAK ------------------------------------------------------

export const archiveJobProfile = (id,page)=>{
    return (dispatch)=>{
           dispatch({type:actionTypes.ARCHIVE_JOB_PROFILE_INITIAL});
           putRequest(`employer/archiveJobProfile/${id}`)
           .then(res=>{
            if(res.data.responseStatus.statusCode ===0 ){
                    const newres = res
                    postRequest(`employer/viewJobProfile?page=${page}&limit=6`,{"searchByJobTitleOrSkill": []})
                    .then(res=>{
                     
                        const record = res.data.responseData.commonPaginationResponse==undefined?0:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
                        const jobProfileDetails = res.data.responseData.jobProfileDetails==undefined ?[]:res.data.responseData.jobProfileDetails
                        if(res.data.responseData.jobProfileDetails==undefined){
                            return dispatch({
                                type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                                payload : false,
                                nodata:true
                                })
                        }
                        const newArr = jobProfileDetails.map(element=>{
                            return (
                                {
                                    jobTitle: element.jobTitle,
                                    id:element.id,
                                    created:element.created,
                                    clientName:element.clientName,
                                    maxExperience: element.maxExperience,
                                    minExperience: element.minExperience,
                                    mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
                                    otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
                                    otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
                                    preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[],
                                    allJobSkillsWithPreecedence: element.allJobSkillsWithPreecedence !==null?element.allJobSkillsWithPreecedence:[],
                                    candidateId: element.candidateId
                                }
                            )
                        })
                        
                     if(res.data.responseStatus.statusCode ===0 ){
                        return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_SUCCESS,
                             payload :newArr,
                             records:record
                         })    
                     }
                     else{
                         return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                         })
                     }
                    }).catch(err=>{
                        return dispatch({
                        type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                        payload : true,
                        })
                    }).then(res=>{
                    return dispatch({
                        type:actionTypes.ARCHIVE_JOB_PROFILE_SUCCESS,
                    })   
                    })
            }
            else{
                return dispatch({
                    type:actionTypes.ARCHIVE_JOB_PROFILE_FAIL,
                    payload : false,
                    nodata:true
                })
            }
           })
           .catch(error =>{
            return dispatch({
                type:actionTypes.ARCHIVE_JOB_PROFILE_FAIL,
                payload :true,
                nodata:false
            })
           })
    }
}

//-------------------- API CREATE JOB PROFILE - DEEPAK ------------------------------------------------------

export const createJobProfile = (data,page)=>{
    console.log(data.entries())
    return (dispatch)=>{
           dispatch({type:actionTypes.CREATE_JOB_PROFILE_INITIAL});
           postRequest(`candidate/createJobProfile`,data)
           .then(res=>{
            if(res.data.responseStatus.statusCode ===0 ){
                    const newres = res
                    postRequest(`employer/viewJobProfile?page=${page}&limit=6`,{"searchByJobTitleOrSkill": []})
                    .then(res=>{
                    
                        if(res.data.responseData.jobProfileDetails==undefined){
                            return dispatch({
                                type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                                payload : false,
                                nodata:true
                            })
                        }  
                        const newArr = res.data.responseData.jobProfileDetails.map(element=>{
                            return (
                                {
                                    jobTitle: element.jobTitle,
                                    id:element.id,
                                    created:element.created,
                                    clientName:element.clientName,
                                    maxExperience: element.maxExperience,
                                    minExperience: element.minExperience,
                                    mustHaveJobSkills: element.mustHaveJobSkills !==null ?element.mustHaveJobSkills:[],
                                    otherMustHaveSkills: element.otherMustHaveSkills !==null ?element.otherMustHaveSkills:[],
                                    otherPreferredSkills: element.otherPreferredSkills !==null ?element.otherPreferredSkills:[],
                                    preferredJobSkills: element.preferredJobSkills !==null ?element.preferredJobSkills:[],
                                    allJobSkillsWithPreecedence: element.allJobSkillsWithPreecedence !==null?element.allJobSkillsWithPreecedence:[],
                                    candidateId: element.candidateId
                                }
                            )
                        })
                     if(res.data.responseStatus.statusCode ===0 ){
                      
                         return dispatch({
                            type:actionTypes.VIEW_JOB_PROFILE_SUCCESS,
                            payload :newArr,
                            records:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
                         })    
                     }
                     else{
                         return dispatch({
                             type:actionTypes.VIEW_JOB_PROFILE_FAIL,
                             payload:false,
                             nodata:true
                         })
                     }
                    }).then(res=>{
                    return dispatch({
                        type:actionTypes.CREATE_JOB_PROFILE_SUCCESS,
                        payload:false
                    })   
                    })
                  
            }
            else{
                return dispatch({
                    type:actionTypes.CREATE_JOB_PROFILE_FAIL,
                    payload :true
                })
            }
           })
           .catch(error =>{
            return dispatch({
                type:actionTypes.CREATE_JOB_PROFILE_FAIL,
                payload :true
            })
           })
    }
}
